<template>
  <v-container fluid>
      <v-row dense>
        <v-col cols="6">
          <v-card
            class="mx-auto hidden-xs-only"
            outlined
            shaped
          >
            <v-list-item three-line>
              <v-list-item-content>
                <div class="text-overline mb-4">
                  HOME
                </div>
                <v-list-item-title class="text-h4 mb-1">
                  {{ getScore(getConst.Team.HOME) }}
                </v-list-item-title>
                <v-list-item-subtitle class="text-h6" v-text="processTeamName(getTeam(getConst.Team.HOME).longName)"></v-list-item-subtitle>
              </v-list-item-content>

              <v-list-item-avatar
                tile
                width="96"
                height="56"
              ><v-img :src="getTeamLogo(getConst.Team.HOME)"></v-img></v-list-item-avatar>
            </v-list-item>
          </v-card>
          <v-card
            class="mx-auto hidden-sm-and-up"
            outlined
            shaped
          >
            <v-list-item three-line>
              <v-list-item-content>
                <div class="text-overline mb-4">
                  HOME
                </div>
                <v-img
                  :src="getTeamLogo(getConst.Team.HOME)"
                  contain
                  height="56"
                ></v-img>
                <v-list-item-title class="text-h4 mb-1">
                  {{ getScore(getConst.Team.HOME) }}
                </v-list-item-title>
                <v-list-item-subtitle class="text-h6" v-text="processTeamName(getTeam(getConst.Team.HOME).boardName)"></v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
          </v-card>
        </v-col>
        <v-col cols="6"><v-card
            class="mx-auto hidden-xs-only"
            outlined
            shaped
          >
            <v-list-item three-line>
              <v-list-item-content>
                <div class="text-overline mb-4">
                  GUEST
                </div>
                <v-list-item-title class="text-h4 mb-1">
                  {{ getScore(getConst.Team.GUEST) }}
                </v-list-item-title>
                <v-list-item-subtitle class="text-h6" v-text="processTeamName(getTeam(getConst.Team.GUEST).longName)"></v-list-item-subtitle>
              </v-list-item-content>

              <v-list-item-avatar
                tile
                width="96"
                height="56"
              ><v-img :src="getTeamLogo(getConst.Team.GUEST)"></v-img></v-list-item-avatar>
            </v-list-item>
          </v-card>
          <v-card
            class="mx-auto hidden-sm-and-up"
            outlined
            shaped
          >
            <v-list-item three-line>
              <v-list-item-content>
                <div class="text-overline mb-4">
                  GUEST
                </div>
                <v-img
                  :src="getTeamLogo(getConst.Team.GUEST)"
                  contain
                  height="56"
                ></v-img>
                <v-list-item-title class="text-h4 mb-1">
                  {{ getScore(getConst.Team.GUEST) }}
                </v-list-item-title>
                <v-list-item-subtitle class="text-h6" v-text="processTeamName(getTeam(getConst.Team.GUEST).boardName)"></v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
          </v-card>
        </v-col>
      </v-row>
      <v-card
        class="mx-auto mt-3"
        outlined
        shaped
        v-for="message in messages"
        :key="message.id"
        color="blue-grey darken-2"
      >
      <v-list-item 
        three-line
      >
        <v-list-item-content>
          <v-list-item-title 
            class="text-body-2 white--text"
            v-if="!(message.quarter==getConst.Quarter.PREGAME || message.quarter==getConst.Quarter.HALFTIME || message.quarter==getConst.Quarter.FINAL)"
          >{{ subtitle(message) }}</v-list-item-title>
          <v-list-item-subtitle 
            class="text-h6 white--text"
            v-if="!(message.quarter==getConst.Quarter.PREGAME || message.quarter==getConst.Quarter.HALFTIME || message.quarter==getConst.Quarter.FINAL)"
          >
            {{ subscore(message) }}
          </v-list-item-subtitle>
          <v-list-item-subtitle 
            class="text-body-1 white--text"
            v-if="!(message.quarter==getConst.Quarter.PREGAME || message.quarter==getConst.Quarter.HALFTIME || message.quarter==getConst.Quarter.FINAL)"
          >
            {{ message.message }}
          </v-list-item-subtitle>
          <v-list-item-subtitle 
            class="text-h6 white--text"
            v-if="(message.quarter==getConst.Quarter.PREGAME || message.quarter==getConst.Quarter.HALFTIME || message.quarter==getConst.Quarter.FINAL)"
          >
            {{ message.message }}
          </v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>
      </v-card>
  </v-container>
</template>

<script>
  import axios from 'axios';
  export default {
    name: 'ViewBoard',

    data: function() {
      return {
        messages: [],
        teams: [],
        getConst: {
          Team: {
              HOME: 0,
              GUEST: 1,
              NONE: 2
          },
          Quarter: {
              PREGAME: 0,
              FIRST: 1,
              SECOND: 2,
              HALFTIME: 3,
              THIRD: 4,
              FOURTH: 5,
              OVERTIME: 6,
              FINAL: 7
          },
        }
      }
    },
    methods: {
      mapQuarter: function(quarter) {
          if (quarter==this.getConst.Quarter.PREGAME) {
              return "PreGame"
          } else if (quarter==this.getConst.Quarter.FIRST) {
              return "1st"
          } else if (quarter==this.getConst.Quarter.SECOND) {
              return "2nd"
          } else if (quarter==this.getConst.Quarter.HALFTIME) {
              return "HalfTime"
          } else if (quarter==this.getConst.Quarter.THIRD) {
              return "3rd"
          } else if (quarter==this.getConst.Quarter.FOURTH) {
              return "4th"
          } else if (quarter==this.getConst.Quarter.OVERTIME) {
              return "OT"
          } else if (quarter==this.getConst.Quarter.FINAL) {
              return "Final"
          }
      },
      processTeamName: function(name) {
        if (name) { return name } 
        else { return "..."}
      },
      getScore: function(team) {
        let score = 0;
        if (this.messages.length>0) {        
          let lastMessage = this.messages[0];
          if (team==this.getConst.Team.HOME && lastMessage.scorehome) {
            score = parseInt(lastMessage.scorehome)
          } else if (team==this.getConst.Team.GUEST && lastMessage.scoreguest) {
            score = parseInt(lastMessage.scoreguest)
          }
        }
        if (score<10) {
          return "0"+score;
        } else {
          return ""+score;
        }
      },
      getTeam: function(team) {
        if (this.messages.length>0) {        
          let lastMessage = this.messages[0];
          if (this.teams.length>0) {
            if (team==this.getConst.Team.HOME) {
              let temp = this.teams.filter(team=>team.shortName==lastMessage.home)
              return (temp.length!==1) ? {} : temp[0]
            } else if (team==this.getConst.Team.GUEST) {
              let temp = this.teams.filter(team=>team.shortName==lastMessage.guest)
              return (temp.length!==1) ? {} : temp[0]
            }
          }
        }
        return {}
      },
      getTeamLogo: function(team) {
        if (this.getTeam(team).iconLink) {     
          return this.getTeam(team).iconLink
        } else {
          return process.env.BASE_URL+"blank.png"
        }
      },
      subtitle: function(message) {
        let text = "";
        if (message.quarter==this.getConst.Quarter.FIRST || 
            message.quarter==this.getConst.Quarter.SECOND ||
            message.quarter==this.getConst.Quarter.THIRD ||
            message.quarter==this.getConst.Quarter.FOURTH ||
            message.quarter==this.getConst.Quarter.OVERTIME) {
              text = this.mapQuarter(message.quarter) + " Quarter | " + message.etime;
            } else {
              text = this.mapQuarter(message.quarter);
            }
        return text
      },
      subscore: function(message) {
        let text = "";
        if (message.quarter==this.getConst.Quarter.FIRST || 
            message.quarter==this.getConst.Quarter.SECOND ||
            message.quarter==this.getConst.Quarter.THIRD ||
            message.quarter==this.getConst.Quarter.FOURTH ||
            message.quarter==this.getConst.Quarter.OVERTIME) {
              text = message.scorehome + ":"+message.scoreguest;
            } else {
              text = this.mapQuarter(message.quarter);
            }
        return text
      },
      loadMessages: function() {
          axios
          .get('https://j2rgtmhiuh.execute-api.eu-central-1.amazonaws.com/live/messages')
          .then((response) => {
              this.messages = response.data
          })
      }
    },
    created: function() {
        axios
            .get('https://j2rgtmhiuh.execute-api.eu-central-1.amazonaws.com/live/teams?style=2021')
            .then((response) => {
                this.teams = response.data
            })
        this.loadMessages()
        setInterval(() => {
          this.loadMessages();
        }, 10000);
    }
  }
</script>
